import styled from "styled-components"
import { Link } from "gatsby"

export const HeaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  display: flex;
  flex-direction: column;
  z-index: 101;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.8);
`

export const LogoLink = styled(Link)`
  display: inline-block;
  max-height: 40px;
  align-self: center;
  padding-left: 15px;
`

export const FlexWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  height: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

export const ChapterTitle = styled.h2`
  text-align: center;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  padding: 5px 0;
`
